module.exports = __webpack_public_path__ + "img/detailed_cashfloat_icon.ab875ebb.png";